<template>
  <div class="PersonMissionListWeb">
    <v-data-table
      dense
      :disable-sort="false"
      :headers="headers"
      :hide-default-footer="!pagination"
      :disable-pagination="!pagination"
      :items="list"
      @click:row="handleClick"
      item-key="MessageId"
    />
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
    pagination: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      headers: [
        {
          text: this.$t("missionType"),
          value: "Name",
        },
        {
          text: this.$t("BeginDate"),
          value: "BeginDate",
        },
        {
          text: this.$t("BeginTime"),
          value: "BeginTime",
        },
        {
          text: this.$t("EndDate"),
          value: "EndDate",
        },
        {
          text: this.$t("EndTime"),
          value: "EndTime",
        },
        {
          text: this.$t("RequestDate"),
          value: "IssueDate",
        },
        {
          text: this.$t("status"),
          value: "StatusType",
        },
      ],
    };
  },
  methods: {
    handleClick(value) {
      this.$emit("onClickMission", value);
    },
  },
};
</script>

<style>
</style>